<template>
    <!-- <AlertBox v-if="$page.props.flash.success || $page.props.flash.error" :message="$page.props.flash.success || $page.props.flash.error" :type="$page.props.flash.error ? 'error' : 'success'" /> -->
    <div class="min-h-screen-ios min-h-screen flex flex-col justify-center py-12 sm:px-6 lg:px-8 sm:bg-gray-300 text-regal-blue-900 pb-36">
       <div class="sm:mx-auto sm:w-full sm:max-w-screen-lg">
           <div class="bg-white w-full rounded-3xl">
               <div class="min-w-screen flex flex-col items-center justify-center p-8 space-y-4">
                   <div class="text-3xl font-bold tracking-tight">
                       Picked the wrong subscription?
                   </div>
                   <div class="text-center text-gray-800">
                       Shop around then come back to pay!
                   </div>
                   <Link :href="route('explore.index')">
                        <Button label="Go back" />
                    </Link>
               </div>
           </div>

       </div>
   </div>

</template>

<script>
    import { useForm } from '@inertiajs/inertia-vue3'
    import InlineError from '@/Shared/InlineError'
    import Button from '@/Shared/Button'
    import { ref } from 'vue'
    import { Inertia } from '@inertiajs/inertia'

    export default {
        setup(props) {
            const submit = () => {
                Inertia.post(route('accounts.createPortalSession'))
            }
            return {submit}
        },
        components: { Button },
        props: {
            account: Object
        },
    }
</script>
